(() => {
  'use strict';
  const canonical = 'https://wandryshop.myshopify.com/pages/advertorial-04';
  const source = new URL(location.href);
  const title = document.title;
  const x = document.getElementById('shX');
  const line = document.getElementById('shLine');
  const copy = document.getElementById('shCopy');
  const feedback = document.getElementById('shDone');
  if (x) x.href = 'https://twitter.com/intent/tweet?text=' + encodeURIComponent(title) + '&url=' + encodeURIComponent(canonical);
  if (line) line.href = 'https://social-plugins.line.me/lineit/share?url=' + encodeURIComponent(canonical);
  let feedbackTimer;
  function message(text) {
    if (!feedback) return;
    clearTimeout(feedbackTimer);
    feedback.textContent = text;
    feedback.style.display = 'inline';
    feedbackTimer = setTimeout(() => { feedback.style.display = 'none'; }, 3000);
  }
  if (feedback) { feedback.setAttribute('role', 'status'); feedback.setAttribute('aria-live', 'polite'); }
  if (copy) copy.addEventListener('click', async () => {
    try {
      await navigator.clipboard.writeText(canonical);
      message('リンクをコピーしました');
    } catch (_) {
      message('コピーできませんでした。アドレスバーからコピーしてください。');
    }
  });
  const passThrough = new Set(['fbclid', 'gclid', 'ttclid', 'ad_id', 'adset_id', 'campaign_id', 'placement', 'ec_qa']);
  document.querySelectorAll('a[data-wandry-cta]').forEach((a, index) => {
    const target = new URL(a.getAttribute('href'), location.href);
    for (const [key, value] of source.searchParams) {
      if (key.startsWith('utm_') || passThrough.has(key)) target.searchParams.set(key, value);
    }
    target.searchParams.set('article', '04');
    a.href = target.href;
    a.dataset.ecCta = String(index + 1);
    a.addEventListener('click', () => {
      try { window.EC_MEASURE?.event('article_product_click'); } catch (_) {}
    });
  });
  const bar = document.getElementById('fc');
  const sitebar = document.querySelector('.sitebar');
  let scheduled = false;
  function update() {
    const visible = scrollY > innerHeight * 1.2;
    if (bar) { bar.classList.toggle('on', visible); bar.inert = !visible; bar.setAttribute('aria-hidden', String(!visible)); }
    if (sitebar) document.documentElement.style.setProperty('--article-anchor-offset', (sitebar.getBoundingClientRect().height + 12) + 'px');
    scheduled = false;
  }
  function schedule() { if (!scheduled) { scheduled = true; requestAnimationFrame(update); } }
  addEventListener('scroll', schedule, { passive: true });
  addEventListener('resize', schedule);
  addEventListener('pageshow', schedule);
  update();
})();

/* 2026-09-23: 画像の先読み。主画像の読込後に、画面の3000px手前に入った画像を先に読み込み、さらに上から順に2枚ずつ先読みする。主画像の表示を遅らせないため、主画像が終わるまでは通常の遅延読込のまま。 */
(() => {
  'use strict';
  const images = Array.from(document.querySelectorAll('#wa04 .wrap img[loading="lazy"]'));
  if (!images.length) return;
  const started = new WeakSet();
  function start(img) {
    if (started.has(img)) return;
    started.add(img);
    img.loading = 'eager';
    img.fetchPriority = 'low';
  }
  function observe() {
    if (!('IntersectionObserver' in window)) { images.forEach(start); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { start(e.target); io.unobserve(e.target); } });
    }, { rootMargin: '3000px 0px 3000px 0px' });
    images.forEach((img) => io.observe(img));
  }
  function trickle() {
    let i = 0;
    const next = () => {
      while (i < images.length && started.has(images[i])) i++;
      if (i >= images.length) return;
      const img = images[i++];
      start(img);
      if (img.complete) next(); else { img.addEventListener('load', next, { once: true }); img.addEventListener('error', next, { once: true }); }
    };
    next(); next();
  }
  const go = () => { observe(); ('requestIdleCallback' in window ? requestIdleCallback(trickle, { timeout: 1500 }) : setTimeout(trickle, 300)); };
  const hero = document.querySelector('#wa04 .hero img');
  if (!hero || (hero.complete && hero.naturalWidth > 0)) go();
  else { hero.addEventListener('load', go, { once: true }); hero.addEventListener('error', go, { once: true }); }
})();
